const n3Factor = {
    'Kołowy': 0.85, 
    'Kwadratowy': 1  
};

export default n3Factor;